export const GET_PR_DETAILS = "GET_PR_DETAILS"
export const GET_PR_ATTACHMENTS = "GET_PR_ATTACHMENTS"
export const GET_PR_ATTACHMENTSLIST = "GET_PR_ATTACHMENTSLIST"
export const SET_APPROVER_RESPONSE = "SET_APPROVER_RESPONSE"
